import { getPath } from '@speeki/client-admin';

import {
    StatisticsCard,
    StatisticsCardProps,
} from '@components/molecules/StatisticsCards/StatisticsCard';

interface IncidentsCardProps
    extends Pick<StatisticsCardProps, 'statistics' | 'hidden' | 'loading'> {}

export const IncidentsCard = ({
    hidden,
    loading,
    statistics,
}: IncidentsCardProps) => {
    return (
        <StatisticsCard
            actionLink={{
                href: getPath({
                    path: '/incidents/dashboard',
                }),
                text: 'Go to Incidents',
            }}
            description="Summary of your incidents statuses."
            hidden={hidden}
            loading={loading}
            statistics={statistics}
            title="Incidents"
        />
    );
};
